<template>
  <div class="">
    <card class="mt-15">
      <div slot="header">
        <h3 class="card-title">기타 의견</h3>
      </div>
      <el-input
        v-model="etcComment"
        type="textarea"
        :rows="4"
        placeholder="집비오에게 하고 싶은 말이 있으신가요? 여기에 남겨주세요."
        @input="SendData()"
      ></el-input>
    </card>
  </div>
</template>

<script>
import { Card, Input } from "element-ui";
import { createNamespacedHelpers, mapGetters } from "vuex";

const { mapGetters: sessionMapGetters } = createNamespacedHelpers(
  "loginSession"
);
export default {
  components: {
    Card,
    [Input.name]: Input
  },

  data() {
    return {
      etcComment: null //기타 의견
    };
  },

  created() {},

  computed: {
    ...sessionMapGetters({
      sessionPropertyInquiry: "getPropertyInquiry"
    })
  },

  methods: {
    bringData() {
      this.etcComment = this.sessionPropertyInquiry.propertyInfo.etcComment; //기타 의견
    },
    SendData(event) {
      this.$emit("etcComment", event);
    }
  }
};
</script>

<style></style>
